export enum ErrorCodes {

  // Airport
  AIRPORT_NOT_FOUND = '100',
  AIRPORT_NEW_WITH_ID = '101',
  AIRPORT_IATA_NOT_FOUND = '102',
  AIRPORT_NO_COORDINATES = '103',
  AIRPORT_IATA_DUPLICATE = '104',
  AIRPORT_ICAO_DUPLICATE = '105',

  // Airport Observation
  AIRPORT_OBSERVATION_NOT_FOUND = '110',
  AIRPORT_OBSERVATION_NEW_WITH_ID = '111',

  // Airport Operator
  AIRPORT_OPERATOR_NOT_FOUND = '120',
  AIRPORT_OPERATOR_NEW_WITH_ID = '121',

  // Region
  REGION_NOT_FOUND = '130',
  REGION_NEW_WITH_ID = '131',
  REGION_AIRPORT_NOT_FOUND = '132',

  // Runway
  RUNWAY_NOT_FOUND = '140',
  RUNWAY_NEW_WITH_ID = '141',

  // Runway
  TERMINAL_NOT_FOUND = '150',
  TERMINAL_NEW_WITH_ID = '151',

  // File
  FILE_NOT_FOUND = '160',
  FILE_NEW_WITH_ID = '161',

  // Taxes
  TAX_NOT_FOUND = '170',
  TAX_ROUTE_BALEARIC_NOT_FOUND = '171',

  // City
  CITY_NOT_FOUND = '180',

  // Contract Cancel fee
  CONTRACT_CANCEL_FEE_NOT_FOUND = '190',
  CONTRACT_CANCEL_FEE_NEW_WITH_ID = '191',

  // Contract Condition
  CONTRACT_CONDITION_NOT_FOUND = '200',
  CONTRACT_CONDITION_NEW_WITH_ID = '201',
  CONTRACT_CONDITION_NOT_FOUND_MULTIPLE = '202',

  // Contract
  CONTRACT_NOT_FOUND = '210',
  CONTRACT_NEW_WITH_ID = '211',
  CONTRACT_GENERATION_FAIL = '212',
  CONTRACT_SIGNED_MODIFICATION = '213',
  CONTRACT_REVISION_ERROR = '214',
  CONTRACT_HIDE_SHOW_LINES_ERROR = '215',

  // Contribution Flight
  CONTRIBUTION_FLIGHT_NOT_FOUND = '220',
  CONTRIBUTION_FLIGHT_NEW_WITH_ID = '221',
  CONTRIBUTION_FLIGHT_DELETE_ERROR = '222',
  CONTRIBUTION_FLIGHT_CONFIRMED_CANCEL_RESERVATION = '223',
  CONTRIBUTION_FLIGHT_RESERVATION_ERROR = '224',
  CONTRIBUTION_FLIGHT_CONFIRMATION_ERROR = '225',
  CONTRIBUTION_FLIGHT_RESERVATION_FILE_ERROR = '226',

  // Contract Payment Condition
  CONTRACT_PAYMENT_CONDITION_NOT_FOUND = '230',
  CONTRACT_PAYMENT_CONDITION_NEW_WITH_ID = '231',

  // Contract Line
  CONTRACT_LINE_NOT_FOUND = '240',
  CONTRACT_LINE_CONTRACT_MISMATCH = '241',
  CONTRACT_LINE_NEW_WITH_ID = '242',

  // Contribution
  CONTRIBUTION_NOT_FOUND = '250',
  CONTRIBUTION_NEW_WITH_ID = '251',
  CONTRIBUTION_ROUTE_NOT_FOUND = '252',
  CONTRIBUTION_LINE_NOT_FOUND = '253',
  CONTRIBUTION_LINE_CONTRIBUTION_MISMATCH = '254',
  CONTRIBUTION_LINE_ROUTE_MISMATCH = '255',
  CONTRIBUTION_LINE_SALE_LINE_NOT_FOUND = '256',
  CONTRIBUTION_WITH_NO_FLIGHTS = '257',
  CONTRIBUTION_NOT_SENT_REASON_STATUS = '258',
  CONTRIBUTION_NOT_SENT_REASON_FAILED = '259',

  // Route
  ROUTE_NOT_FOUND = '260',
  ROUTE_NEW_WITH_ID = '261',
  ROUTE_WITH_NO_ROTATIONS = '262',
  ROUTE_FIRST_FLIGHT_NOT_FOUND = '263',
  ROUTE_LAST_FLIGHT_NOT_FOUND = '264',
  ROUTE_WITH_NO_FLIGHTS = '265',
  ROUTE_WITH_CONTRIBUTIONS = '266',
  ROUTE_WITH_NO_FREQ_DAYS = '267',
  ROUTE_ROTATION_NOT_FOUND = '268',
  ROUTE_DATES_ERROR = '269',

  // Country
  COUNTRY_NOT_FOUND = '270',

  // Client
  CLIENT_NOT_FOUND = '280',
  CLIENT_NEW_WITH_ID = '281',
  CLIENT_OF_FILE_NOT_FOUND = '282',

  // Contact
  CONTACT_NOT_FOUND = '290',
  CONTACT_NEW_WITH_ID = '291',
  CONTACT_NOT_FOUND_BY_PROVIDER = '292',
  CONTACT_WITHOUT_EMAIL = '293',

  // File Additional Data
  FILE_ADDITIONAL_DATA_NOT_FOUND = '300',
  FILE_ADDITIONAL_DATA_NEW_WITH_ID = '301',

  //

  // Provider
  PROVIDER_NOT_FOUND = '310',
  PROVIDER_NEW_WITH_ID = '311',
  PROVIDER_OF_CONTRIBUTION_NOT_FOUND = '312',

  // Aircraft Base
  AIRCRAFT_BASE_NOT_FOUND = '320',
  AIRCRAFT_BASE_NEW_WITH_ID = '321',
  AIRCRAFT_BASE_MAIN_BASE_NOT_FOUND = '322',

  // Aircraft
  AIRCRAFT_NOT_FOUND = '330',
  AIRCRAFT_NEW_WITH_ID = '331',

  // Aircraft Category
  AIRCRAFT_CATEGORY_NOT_FOUND = '340',
  AIRCRAFT_CATEGORY_NEW_WITH_ID = '341',
  AIRCRAFT_SUBCATEGORY_NOT_FOUND = '342',
  AIRCRAFT_SUBCATEGORY_NEW_WITH_ID = '343',
  AIRCRAFT_CATEGORY_DELETE_WITH_SUBCATEGORIES = '344',

  // Aircraft Category
  AIRCRAFT_OBSERVATION_NOT_FOUND = '350',
  AIRCRAFT_OBSERVATION_NEW_WITH_ID = '351',

  // Contract Deposit
  CONTRACT_DEPOSIT_NOT_FOUND = '352',
  CONTRACT_DEPOSIT_IS_FORMALIZED = '353',

  // Flight
  FLIGHT_NOT_FOUND = '360',
  FLIGHT_NEW_WITH_ID = '361',
  FLIGHT_GET_ROUTE_ERROR = '362',
  FLIGHT_GET_CONTRIBUTION_ERROR = '363',

  // Aircraft Type
  AIRCRAFT_TYPE_NOT_FOUND = '370',
  AIRCRAFT_TYPE_NEW_WITH_ID = '371',
  AIRCRAFT_TYPE_NO_FLIGHT_RANGE = '372',
  AIRCRAFT_TYPE_CODE_REPEATED = '373',

  // Aircraft Type Observation
  AIRCRAFT_TYPE_OBSERVATION_NOT_FOUND = '380',
  AIRCRAFT_TYPE_OBSERVATION_NEW_WITH_ID = '381',

  // Aircraft Type Average Speed
  AIRCRAFT_TYPE_AVG_SPEED_NOT_FOUND = '390',
  AIRCRAFT_TYPE_AVG_SPEED_NEW_WITH_ID = '391',

  // Service
  SERVICE_NOT_FOUND = '410',
  SERVICE_NEW_WITH_ID = '411',
  SERVICE_CATEGORY_NOT_FOUND = '412',
  SERVICE_CATEGORY_NEW_WITH_ID = '413',
  SERVICE_CATEGORY_CONFIG_NOT_FOUND = '414',
  SERVICE_CATEGORY_WITH_SERVICES = '415',
  SERVICE_PAXTAX_NOT_FOUND = '416',
  SERVICE_LANDING_TAX_NOT_FOUND = '417',

  // Operator
  OPERATOR_NOT_FOUND = '420',
  OPERATOR_NEW_WITH_ID = '421',
  OPERATOR_WITHOUT_PROVIDER = '422',
  OPERATOR_FOR_PROVIDER_NOT_FOUND = '423',

  // Operator Comment
  OPERATOR_COMMENT_NOT_FOUND = '430',

  // Task
  TASK_NOT_FOUND = '450',
  TASK_NEW_WITH_ID = '451',

  // Screen
  SCREEN_NOT_FOUND = '460',
  SCREEN_NEW_WITH_ID = '461',

  // User
  USER_NOT_FOUND = '470',
  USER_TOKEN_NOT_FOUND = '471',
  USER_SYSTEM_NOT_FOUND = '472',
  USER_USERNAME_NOT_FOUND = '473',
  USER_FOR_MENU_NOT_FOUND = '474',
  USER_EMAIL_NOT_FOUND = '475',
  USER_PASSWORD_NOT_VALID = '476',
  USER_DISABLED = '477',
  USER_NOT_EXTERNAL = '478',
  USER_USERNAME_EMAIL_DUPLICATED = '479',

  // Conversion
  CONVERSION_FLIGHT_RANGE_ERROR = '480',

  // Filter
  FILTER_PARAMS_INVALID_OPERATOR = '490',
  FILTER_PARAMS_INVALID_PARAMS = '491',

  // State
  STATE_CHANGE_FILE = '500',
  STATE_CHANGE_CONTRIBUTION = '501',
  STATE_CHANGE_CONTRACT = '502',
  STATE_CHANGE_CONTRIBUTION_FLIGHT = '503',

  // Proforma
  PROFORMA_NOT_FOUND = '600',
  PROFORMA_NEW_WITH_ID = '601',
  PROFORMA_LINE_NOT_FOUND = '602',
  PROFORMA_LINE_PROFORMA_MISMATCH = '603',
  PROFORMA_LINE_NEW_WITH_ID = '604',

  // Generación pdf
  PDF_GENERATION_ERROR = '700',
  PDF_GENERATION_TEMPLATE_ERROR = '701',

  // Pago
  PAYMENT_METHOD_NOT_FOUND = '800',
  PAYMENT_METHOD_NEW_WITH_ID = '801',

  // Plantillas
  COST_TEMPLATE_NOT_FOUND = '900',
  COST_TEMPLATE_NEW_WITH_ID = '901',
  CONTRACT_TEMPLATE_NOT_FOUND = '902',
  CONTRACT_TEMPLATE_NEW_WITH_ID = '903',

  // Aicraft ID
  AIRCRAFT_PLATE_NUMBER_NOT_FOUND = '910',

  // Operated Flights
  OPERATED_FLIGHT_NOT_FOUND = '920',

  // Delay
  DELAY_NOT_FOUND = '930',
  DELAY_CODE_NOT_FOUND = '931',

  // Delay Families
  DELAY_FAMILY_NOT_FOUND = '940',

  // Cancel Fees
  CANCEL_FEE_NOT_FOUND = '950',
  CANCEL_FEE_SERVICE_NOT_FOUND = '951',
  CANCEL_FEE_APPLICABLE_NOT_FOUND = '952',
  CANCEL_FEE_CHANGE_STATUS_ERROR = '953',

  // Contract Templates
  PRINT_CONTRACT_TEMPLATE_NOT_FOUND = '970',
  PRINT_CONTRACT_DOCX_TEMPLATE_NOT_FOUND = '971',

  // Statistic Codes
  STATISTIC_CODE_NOT_FOUND = '980',

  // File Broker Share
  FILE_BROKER_SHARE_PERCENT_ERROR = '990',

  // Passenger
  PASSENGER_NEW_WITH_ID = '1001',
  PASSENGER_NOT_FOUND = '1004',
  PASSENGER_FAIL_LOAD = '1002',

  // File load errors
  EXCEL_FILE_LOAD_ERROR = '1101',

  // SSR
  SSR_NOT_FOUND = '1200',

  // Emails
  EMAIL_SENDING_ERROR = '1301',
  EMAIL_UNEXPECTED_ERROR = '1302',
  EMAIL_ATTACHMENT_ERROR = '1303',
  EMAIL_SUBJECT_ERROR = '1304',
  EMAIL_TO_ERROR = '1305',

  // Smartwings
  sMARTWINGS_MAPPING_ERROR = '1401',
  SMARTWINGS_INTEGRATION_ERROR = '1402',

  // Availability requests
  REQUEST_NOT_FOUND = '1501',
  REQUEST_NEW_WITH_ID = '1502',

  // Availability requests emails
  REQUEST_EMAIL_NOT_FOUND = '1601',
  REQUEST_EMAIL_NEW_WITH_ID = '1602',

  // Flight preparation
  FLIGHT_PREPARATION_TASK_NOT_FOUND = '1701',
  FLIGHT_PREPARATION_TASK_NEW_WITH_ID = '1702',
  FLIGHT_PREPARATION_NOT_FOUND = '1703',
  FLIGHT_PREPARATION_TEMPLATE_NOT_FOUND = '1704',
  FLIGHT_PREPARATION_REPORT_REQUEST_NOT_FOUND = '1705',
  FLIGHT_PREPARATION_REPORT_REQUEST_NO_EMAIL_TO = '1706',

  // Reassign ferry flights
  REASSIGN_FLIGHT_ERROR_FILE = '1750',
  REASSIGN_FLIGHT_ERROR_FLIGHTS = '1751',

  // File Operated Movements
  FILE_OPERATED_MOVEMENTS_EMAIL_NOT_FOUND = '1801',
  FILE_OPERATED_MOVEMENTS_NOT_FOUND = '1802',
  FILE_OPERATED_MOVEMENTS_REPORT_NOT_FOUND = '1803',
  FILE_OPERATED_MOVEMENTS_REPORT_NO_EMAIL_TO = '1804',

  // Flight Chart
  FLIGHT_CHART_UPDATE_FL_STATUS_ERROR = '1851',

}

export function getErrorTranslationLabel(enumValue: number | string): string {
  return Object.keys(ErrorCodes).find((x) => ErrorCodes[x] == enumValue);
}
